import { render, staticRenderFns } from "./managedInstruction.vue?vue&type=template&id=a15789b8&scoped=true"
import script from "./managedInstruction.vue?vue&type=script&lang=js"
export * from "./managedInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15789b8",
  null
  
)

export default component.exports